// extracted by mini-css-extract-plugin
export default {"toggle":"GenerationModeToggle-module__toggle--wXNNa","pill":"GenerationModeToggle-module__pill--mdevv","active":"GenerationModeToggle-module__active--yqDOw"};